<template>
    <div class="relative text-center open">
        <div @click="toggleShow" type="primary" class="inline-flex py-2 px-4 text-lg text-white rounded-md cursor-pointer bg-sky-700 border-sky-800 hover:bg-sky-800 hover:border-sky-900 dropdown-toggle">{{ filterbutton }}
            <svg class="mt-1 ml-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg></div>
        <button class="fixed inset-0 h-full w-full cursor-default focus:outline-none" v-if="filterShow" @click="toggleShow" tabindex="-1"></button>
        <filter-panel-component
            v-if="filterShow"
            :selected-filters="selectedFilters"
            :price-min="priceMin"
            :price-max="priceMax"
            :filter-price="filterPrice"
            :filterproperty-type="filterpropertyType"
            :param-url="paramUrl"
            :filter-sleeps="filterSleeps"
            :our-domain="ourDomain"
            :type-options='typeOptions'
            :facilities-list="facilitiesList"
        ></filter-panel-component>
    </div>
</template>
<script>
    import {store,mutations} from "./store";
    export default {
        name: "LazyLoadFilterComponent",
        props: ['selectedFilters','filterPrice','filterpropertyType','paramUrl','filterSleeps','priceMin','priceMax','ourDomain','typeOptions','facilitiesList'],
        components: {
            FilterPanelComponent: () => import('./FilterPanelComponent.vue')
        },
        mounted(){
            const onEscape = (e) => {
                if (e.key === "Esc" || e.key === "Escape") {
                    this.toggleShow(false)
                }
            };

            document.addEventListener("keydown", onEscape);

            this.$once("hook:beforeDestroy", () => {
                document.removeEventListener("keydown", onEscape);
            });
        },
        methods: {
            toggleShow(){
                mutations.toggleFilter();
            }
        },
        computed:{
            filterbutton() {
                if(this.filterShow === true){ return 'Hide Filter'} ;
                if(this.filterShow === false){return 'Filter Results'};
            },
            filterShow(){
                return store.state.filterShow;
            },
        }
    }
</script>


